var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWeatherPrecipitationBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 16.8997c.1609.0327.3246.0577.4907.0745.1047.017.2122.0258.3218.0258H7v4c0 .5523.4477 1 1 1s1-.4477 1-1v-4h2v2c0 .5523.4477 1 1 1s1-.4477 1-1v-2h2v4c0 .5523.4477 1 1 1s1-.4477 1-1v-4h.4375c.0913 0 .1811-.0061.2692-.018A5.7297 5.7297 0 0019 16.7286V19c0 .5523.4477 1 1 1s1-.4477 1-1v-3.391c1.2247-1.0544 2-2.616 2-4.359 0-2.9962-2.2917-5.4572-5.2178-5.7257C16.7048 2.8706 14.1031 1 11.0625 1c-3.7452 0-6.8271 2.8398-7.21 6.4836C2.1655 8.287 1 10.007 1 12c0 1.6361.7854 3.0881 2 4.0002V19c0 .5523.4477 1 1 1s1-.4477 1-1v-2.1003zM17.4375 15v-.0046C19.4215 14.8977 21 13.2582 21 11.25c0-2.0386-1.6266-3.6972-3.6528-3.7488a3.7838 3.7838 0 00-1.0712.1265 5.2162 5.2162 0 00-.3899-1.4536C15.0815 4.3071 13.2247 3 11.0625 3 8.26 3 5.9703 5.196 5.8203 7.961a5.3345 5.3345 0 00.0458 1.042 2.9987 2.9987 0 00-.5876.0843C3.9703 9.4103 3 10.592 3 12c0 1.5939 1.243 2.8974 2.8125 2.9942V15h11.625z",
    fill: "#24272A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherPrecipitationBlack);
export default __webpack_public_path__ + "static/media/Icon-Weather-Precipitation-Black.0c4afecc9121c289fc9e703245832a75.svg";
export { ForwardRef as ReactComponent };